import { __assign, __spreadArrays } from "tslib";
// DS: CMPST04
// [composite of CR51 + C33D + INT01D] https://zpl.io/bWj098K
import React from 'react';
import DeviationsMosaic from '../DeviationsMosaic';
import { Url } from '@wix/da-url';
import { GallectionResourceType } from '../types/gallection';
import ErrorBoundary from '../ErrorBoundary';
import BiLink from '../biLogger/Components/BiLink';
import { BiEventType } from '../biLogger/constants';
import CollectionCardFooter from './CollectionCardFooter';
import CollectionCardOverlay from './CollectionCardOverlay';
import s from './CollectionCard.scss';
var FOOTER_HEIGHT = 45;
export var CollectionCardCMPST04 = function (_a) {
    var style = _a.style, width = _a.width, height = _a.height, gallection = _a.gallection, _b = _a.gallection, owner = _b.owner, type = _b.type, thumb = _b.thumb, additionalThumbs = _b.additionalThumbs, name = _b.name, folderId = _b.folderId, _c = _a.inclusiveFooter, inclusiveFooter = _c === void 0 ? true : _c, dataHook = _a.dataHook;
    var deviations = [];
    if (thumb) {
        deviations.push(thumb);
    }
    if (additionalThumbs) {
        deviations = __spreadArrays(deviations, additionalThumbs);
    }
    // Calculate heights
    var mosaicHeight = inclusiveFooter ? height - FOOTER_HEIGHT : height;
    var fullHeight = inclusiveFooter ? height : 'auto';
    var link = Url.userGalleryLink({
        username: owner.username,
        gallectionType: 'collection',
        folderId: folderId,
        folderName: name,
    });
    return (React.createElement(ErrorBoundary, null,
        React.createElement("div", { className: s['root'], style: __assign(__assign({}, style), { width: width, height: fullHeight }), "data-hook": dataHook },
            React.createElement(BiLink, { href: link, biData: {
                    evid: BiEventType.ITEM_CLICK,
                    itemid: folderId,
                    typeid: GallectionResourceType.COLLECTION,
                } },
                React.createElement("div", { className: s['mosaic'] },
                    React.createElement(DeviationsMosaic, { deviations: deviations, width: width, height: mosaicHeight }),
                    React.createElement(CollectionCardOverlay, { className: s['overlay'], gallection: gallection })),
                React.createElement(CollectionCardFooter, { gallection: gallection })))));
};
CollectionCardCMPST04.displayName = 'CollectionCardCMPST04';
export default CollectionCardCMPST04;
//# sourceMappingURL=CollectionCard.js.map